import React from "react";
import {Box, Grid} from "@mui/material";
import {change, Field, reduxForm} from "redux-form";
import BasicFormTextField from "../../../common/BasicFormTextField";
import { isvalidDateRange, required} from "_helpers";
import CheckboxLabel from "../../../common/CheckboxLabel";
import ActionButton from "../../../common/ActionButton";
import AnchorButton from "../../../common/AnchorButton";
import {useDispatch, useSelector} from "react-redux";
import BasicTimePicker from "../../../common/BasicTimePicker";
import _ from "lodash";
import RatesSelect from "../Utilities/RatesSelect";
import {addSchedulePayloadBuilder, daysOfWeek} from "../Utilities/scheduleUtils";
import {scheduleActions} from "../../../../../_actions";
import ChannelsFilterMultiSelect from "../Utilities/ChannelsFilterMultiSelect";

function AddScheduleForm({ handleSubmit, dataSourceOptions, orgId, payoutRates, pricingRates, organization }){
    const dispatch = useDispatch();
    const timezone = organization?.timezone || 'No timezone set';

    const schedules = useSelector(state => state.schedules);
    const loadingCreateSchedule = schedules.loadingCreateSchedule;

    const onChange = (event) => {
        const name = _.get(event, 'target.name');
        const value = _.get(event, 'target.checked');
        dispatch(change('AddScheduleForm',name, value))
    }

    const handleCreateSchedule = (data) => {
        const payload = addSchedulePayloadBuilder(data, orgId)
        dispatch(scheduleActions.addScheduleV2(payload))
    }

    return(
        <form onSubmit={handleSubmit(handleCreateSchedule)}>
            <Grid container mt={{ xs: '14px', sm: '20px'}}>
                <Grid item sx={styles.formContainer} xs={12} md={6} lg={6}>
                    <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                        <Box sx={styles.inputDesc}>Schedule name</Box>
                        <Field
                            type="text"
                            name="name"
                            component={BasicFormTextField}
                            validate={required}
                        />
                    </Box>

                    <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                        <Box sx={styles.inputDesc}>Days</Box>
                        <Grid container>
                            {daysOfWeek.map(day => {
                                return (
                                    <Grid item xs={3} lg={3} key={day}>
                                        <CheckboxLabel
                                            name={day}
                                            value={day}
                                            label={day}
                                            onChange={onChange}
                                        />
                                    </Grid>
                                )})}
                        </Grid>
                    </Box>

                    <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4}>
                                <Box sx={styles.inputDesc}>Start time</Box>
                                <Field
                                    name="startTime"
                                    component={BasicTimePicker}
                                    type="text"
                                    showSecond={false}
                                    applyValidation={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <Box sx={styles.inputDesc}>End time</Box>
                                <Field
                                    name="endTime"
                                    component={BasicTimePicker}
                                    type="text"
                                    showSecond={false}
                                    applyValidation={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Box sx={styles.inputDesc}>Timezone</Box>
                                <Box sx={{color: "#0C2728", fontSize: 14, fontFamily: 'larsseitRegular'}} >{timezone}</Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box mb={{xs: "15px", sm: "15px", md: "20px", lg: "20px"}}>
                        <Box sx={styles.inputDesc}>Select channel</Box>
                        <Field
                            name="channels"
                            component={ChannelsFilterMultiSelect}
                            options={dataSourceOptions}
                            applyValidation={true}
                        />
                    </Box>

                    <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                        <Box sx={styles.inputDesc}>Payout rates</Box>
                        <Field
                            name="payoutRate"
                            component={RatesSelect}
                            options={payoutRates}
                            applyValidation={true}
                        />
                    </Box>

                    <Box>
                        <Box sx={styles.inputDesc}>Pricing rates</Box>
                        <Field
                            name="pricingRate"
                            component={RatesSelect}
                            options={pricingRates}
                            applyValidation={true}
                        />
                    </Box>

                    <Box sx={styles.footer}>
                        <Box sx={{width: '100px'}}>
                            <ActionButton
                                label={'Save'}
                                disabled={loadingCreateSchedule}
                            />
                        </Box>
                        <Box sx={{width: '100px'}}>
                            <AnchorButton
                                label={'Cancel'}
                                link={`/organizations/${orgId}/settings#expert`}
                                buttonBordered={true}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </form>
    )
}

const styles = {
    formContainer: {
        backgroundColor: '#FFF',
        border: '1px solid #CED4D4',
        borderRadius: '5px',
        padding: '20px'
    },
    inputDesc: {
        fontFamily: 'LarsseitMedium',
        fontSize: '14px',
        fontWeight: 500,
        color: '#495D5E',
        mb: '7px'
    },
    footer: {
        display: 'flex',
        gap: '18px',
        paddingTop: '60px'
    },
}

function validate(values) {
    const errors = {};
    const {startTime, endTime, channels, payoutRate, pricingRate} = values;
    const validDateRange = isvalidDateRange(startTime, endTime);

    if (!validDateRange){
        errors.endTime = "End time must be after Start time"
    }
    if(_.isEmpty(channels)) errors.channels = "This field is required!";
    if(_.isEmpty(startTime)) errors.startTime = "This field is required!";
    if(_.isEmpty(endTime)) errors.endTime = "This field is required!";
    if(_.isEmpty(payoutRate)) errors.payoutRate = "This field is required!";
    if(_.isEmpty(pricingRate)) errors.pricingRate = "This field is required!";

    return errors
}

const formConfig = {
    form: 'AddScheduleForm',
    validate
};

AddScheduleForm = reduxForm(formConfig)(AddScheduleForm)
export default AddScheduleForm